export default {
    path: "/cloud",
    name: "Cloud",
    meta: {
        title: "common.file.cloud",
    },
    redirect: "/cloud/myfiles",
    component: () => import("../../views/Cloud/Cloud.vue"),
    children: [
        {
            path: "myfiles",
            name: "MyFiles",
            meta: {
                title: "common.file.my",
            },
            component: () => import("../../views/Cloud/Myfile/index.vue"),
        },
        {
            path: "shareme",
            name: "ShareMe",
            meta: {
                title: "common.file.joint",
            },
            component: () => import("../../views/Cloud/ShareMe/index.vue"),
        },
        {
            path: "tos",
            name: "ToShare",
            meta: {
                title: "common.myjoint",
            },
            component: () => import("../../views/Cloud/ToShare/index.vue"),
        },
        {
            path: "toshared",
            name: "ToShared",
            meta: {
                title: "common.myshare",
            },
            component: () => import("../../views/Cloud/ToShared/index.vue"),
        },
        {
            path: "collect",
            name: "Collect",
            meta: {
                title: "common.cds14",
            },
            component: () => import("../../views/Cloud/Collect/index.vue"),
        },
        {
            path: "recycle",
            name: "Recycle",
            meta: {
                title: "common.recycle",
            },
            component: () => import("../../views/Cloud/Recycle/index.vue"),
        },
    ],
};
